import { UserSettings } from '@/models/user-settings';

export class SettingsUtils {
  /**
   * Converts a JSON string to a UserSettings object.
   * @param {string} jsonString - The JSON string to be converted.
   * @returns {UserSettings} A UserSettings object.
   * @private
   */
  public static convertFromJsonString(jsonString: string): UserSettings {
    return JSON.parse(jsonString) as UserSettings;
  }
}
